// One row of the run status card's stage list (components/RunStatus.jsx): done, current or to come,
// with an optional short detail on the right and an optional note under the label. Pure props.
import React from "react";
import { C } from "../lib/colors.js";
import { Spinner } from "./ui/Primitives.jsx";
import { IconCheck } from "./ui/Icons.jsx";
import { SoothIcon } from "./Icons.jsx";

/**
 * @param {{label: string, state: "done"|"current"|"todo", detail?: string|null,
 *   note?: string|null}} props `note`: a quieter second line under the label
 */
export default function RunStageRow({ label, state, detail, note }) {
  const color = state === "current" ? C.white : state === "done" ? C.grayL : C.gray;
  return (
    <li
      aria-current={state === "current" ? "step" : undefined}
      style={{
        display: "grid",
        gridTemplateColumns: "20px 1fr auto",
        alignItems: "center",
        columnGap: 10,
        minHeight: 28,
        fontSize: 13,
        color,
        fontWeight: state === "current" ? 500 : 400,
      }}
    >
      <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        {state === "done" ? (
          <IconCheck width={15} height={15} title="Done" style={{ color: C.grayL }} />
        ) : state === "current" ? (
          <Spinner label={label} />
        ) : (
          // A step still to come: the mark at rest, in grey (the current step's mark is lit).
          <span aria-hidden="true" style={{ display: "flex", opacity: 0.6 }}>
            <SoothIcon size={16} color={C.gray} />
          </span>
        )}
      </span>
      <span>{label}</span>
      {detail ? (
        <span className="sy-num" style={{ fontSize: 12, color: C.gray, fontWeight: 400 }}>
          {detail}
        </span>
      ) : (
        <span />
      )}
      {note ? (
        <span
          style={{
            gridColumn: "2 / 4",
            fontSize: 12,
            lineHeight: 1.5,
            color: C.gray,
            fontWeight: 400,
          }}
        >
          {note}
        </span>
      ) : null}
    </li>
  );
}
